import React from 'react';

import { useIntl } from 'react-intl';

import useDialogModal, { DialogCb } from 'hooks/use-dialog-modal';

interface IResetConfirmDialogHook {
  openConfirmationDialog: DialogCb<object>;
  ResetConfirmDialog: JSX.Element;
}

export function useResetConfirmDialog(callback: DialogCb<object>): IResetConfirmDialogHook {
  const { formatMessage } = useIntl();
  const [ConfirmationDialog, openConfirmationDialog] = useDialogModal({
    onConfirm: callback,
    showCancel: true,
  });

  const ResetConfirmDialog = (
    <ConfirmationDialog
      heading={formatMessage({ id: 'resetCustomizationsHeader' })}
      body={formatMessage({ id: 'resetCustomizationsDescription' })}
      confirmLabel={formatMessage({ id: 'continue' })}
      cancelLabel={formatMessage({ id: 'cancel' })}
    />
  );

  return {
    openConfirmationDialog,
    ResetConfirmDialog,
  };
}
